import { Schema } from "prosemirror-model";
import { nodes } from "prosemirror-schema-basic";
import { mention } from "./nodes/mention";

export type MentionInputNodes =
	| "paragraph"
	| "text"
	| "hard_break"
	| "mention";

export type MentionInputSchema = Schema<MentionInputNodes>;

export const mentionInputSchema = new Schema<MentionInputNodes>({
	nodes: {
		paragraph: nodes.paragraph,
		text: nodes.text,
		hard_break: nodes.hard_break,
		mention: mention
	},
	topNode: "paragraph"
});